// extracted by mini-css-extract-plugin
module.exports = {"viewDownloadsModalWrapper":"rS","header":"rT","headline":"rU","closeIcon":"rV","modalCloseIcon":"rW"};